export const TRANSLATIONS_ES_SETTINGS_GOOGLE = {
  "settings.google.connection_status_title": "Estado de conexión",
  "settings.google.loading_status": "Cargando estado...",
  "settings.google.connected": "Conectado",
  "settings.google.connect_button": "Conectar con Google",
  "settings.google.no_accounts": "No hay cuentas conectadas.",
  "settings.google.gmail_messages_title": "Mensajes de Gmail",
  "settings.google.no_messages": "No hay mensajes para mostrar.",
  "settings.google.drive_files_title": "Archivos de Drive",
  "settings.google.root": "(Raíz)",
  "settings.google.no_files": "No hay archivos para mostrar.",
  "settings.google.diagnostics_title": "Diagnóstico y pruebas",
  "settings.google.audit_title": "Auditoría y seguridad",
  "settings.google.manage_access_link": "Gestionar acceso en mi cuenta de Google",
  "settings.google.privacy_policy": "Política de privacidad",
  "settings.google.terms_of_service": "Términos del servicio",
  "settings.google.multi_account_title": "Gestión multi‑cuenta",
  "settings.google.reauthorize": "Reautorizar",
  "settings.google.revoke": "Revocar",
  "settings.google.make_default": "Por defecto",
  "settings.google.oauth_processing": "Procesando autenticación con Google...",
  "settings.google.table.subject": "Asunto",
  "settings.google.table.from": "De",
  "settings.google.table.received_at": "Recibido",
  "settings.google.table.body_preview": "Vista previa",
  "settings.google.table.has_attachments": "Adjuntos",
  "settings.google.table.name": "Nombre",
  "settings.google.table.type": "Tipo",
  "settings.google.table.size": "Tamaño",
  "settings.google.table.modified": "Modificado",
  "settings.google.table.created_by": "Creado por",
  "settings.google.table.status": "Estado",
  "settings.google.table.time": "Hora",
  "settings.google.table.message": "Mensaje",
  "settings.google.table.account": "Cuenta",
  "settings.google.table.scopes": "Permisos",
  "settings.google.table.default": "Por defecto",
  "settings.google.table.actions": "Acciones",
  "settings.google.table.sync_period": "Sincronizar desde",
  "settings.google.save_sync_start_date": "Guardar fecha",
  'settings.google.sync_process_title': 'Sincronización de cuenta',
  'settings.google.sync.mail_sync_status': 'Estado sincronización correo',
  'settings.google.sync.drive_sync_status': 'Estado sincronización drive',
  'settings.google.sync.last_read_email_date': 'Fecha del último correo sincronizado',
  'settings.google.sync.last_sync_date': 'Última sincronización',
  'settings.google.sync.emails_processed': 'Correos procesados',
  'settings.google.sync.period': 'Periodo a sincronizar',
  'settings.google.sync.period_updated_prefix': 'Fecha de inicio de sincronización actualizada a',
  'settings.google.sync.resync_requested': 'Re-sincronización solicitada.',
  'settings.google.sync.set_period': 'Establecer periodo',
  'settings.google.sync.all': 'Todos',
  'settings.google.sync.not_set': 'No definido',
};
